import { Grid, Typography } from '@mui/material';
import React, { useEffect } from 'react';
// import { CopyCount } from '../GetRatesV2/StyleComponent';
import { BoxContainer } from '../CreateShipment/styles';
import { BoxType } from '../../store/reducers/Shipment/Type';
import { AppDispatch, RootStateType } from '../../store';
import { useDispatch, useSelector } from 'react-redux';
import { UNIT } from '../../services/calculateVolume';
import { AddressType } from '@Reducers/GetRates/Type';
import { getChargeableWeight } from '@Reducers/GetRates/actions';
import { customWeightRounding } from '../../utils/convertWeight';

interface PropsType {
  box: BoxType;
  setSelectedBox: (box: BoxType) => void;
  isSelected: boolean;
}

function BoxInfo({ value, label }: { label: string; value: string }) {
  return (
    <Grid container className="mb-1/2" display="grid" gridTemplateColumns="2fr 1fr" gap={1}>
      <Grid item>
        <Typography className="sm-text">{label}</Typography>
      </Grid>
      <Grid item textAlign="left">
        <Typography className="sm-text">{value}</Typography>
      </Grid>
    </Grid>
  );
}

function getAddressObj({ pincode, city, country, state }: AddressType) {
  return { city, state, country, pincode };
}

function SingleBoxView({ box, setSelectedBox, isSelected }: PropsType) {
  const dispatch = useDispatch<AppDispatch>();
  const { shipmentById } = useSelector((state: RootStateType) => state.shipment);
  const { chareableWeight } = useSelector((state: RootStateType) => state.getRates);
  const selectedUnit = shipmentById?._packageId.unitOfMeasurement.split('-')[0];
  const selectedLengthUnit: UNIT =
    shipmentById?._packageId.unitOfMeasurement.split('-')[1] === UNIT.cm ? UNIT.cm : UNIT.in;
  // const { boxCopyCount, id, weight, length, width, height, startCount = 0 } = box;
  const { id, weight, length, width, height } = box;

  function finalCharegableWTByID() {
    if (shipmentById?.shipmentNumber) {
      const obj = {
        destination: { ...getAddressObj(shipmentById?._consigneeId) },
        source: { ...getAddressObj(shipmentById?._shipperId) },
        package: {
          box: shipmentById?._packageId?.box?.map(box => ({
            weight: box.weight.toString(),
            length: Number(box.length),
            width: Number(box.width),
            height: Number(box.height),
          })),
          unitOfMeasurement: selectedUnit || shipmentById?._packageId?.unitOfMeasurement.split('-')[0],
        },
        document: shipmentById?._packageId?.isDocument,
        _courierId: shipmentById?.sellingPricing?._courierId,
        shipmentEdit: true,
        inbound: shipmentById?.sellingPricing?.inbound,
        outbound: shipmentById?.sellingPricing?.outbound,
        shipmentNumber: shipmentById?.shipmentNumber,
      };
      dispatch(getChargeableWeight({ ...obj }));
    }
  }

  useEffect(() => {
    finalCharegableWTByID();
  }, []);

  return (
    <>
      <BoxContainer
        container
        alignItems={'center'}
        className={`rounded-lg`}
        isselected={String(isSelected)}
        onClick={() => {
          setSelectedBox(box);
          // setSelectedProduct({ ...defaultProductState });
        }}
      >
        <Grid container item justifyContent="space-between" alignItems="center">
          <Grid container justifyContent="space-between">
            <Grid container item xs={11} className="mb-1">
              <Typography className="md-text font-bold">{`Box ${Number(id) + 1}`}</Typography>
              {/* <Typography className="md-text font-bold">Box 1-3</Typography> */}
              {/* {boxCopyCount && boxCopyCount > 0 ? (
                <CopyCount className="sm-text ml-1 px-1 rounded-xs">x {boxCopyCount}</CopyCount>
              ) : (
                <></>
              )} */}
            </Grid>
          </Grid>
          <BoxInfo label="Actual Weight" value={`${weight || 0} ${selectedUnit}`} />
          <BoxInfo
            label="Volumetric Weight"
            value={`${
              chareableWeight?.boxWiseArr && chareableWeight?.boxWiseArr?.[Number(id)]?.maxVolumetricWeight
                ? selectedUnit === 'lb'
                  ? (chareableWeight.boxWiseArr?.[Number(id)].maxVolumetricWeight * 2.20462).toFixed(2)
                  : chareableWeight.boxWiseArr?.[Number(id)].maxVolumetricWeight.toFixed(2)
                : (0).toFixed(2)
            } ${selectedUnit}`}
          />
          <BoxInfo
            label="Chargeable Weight"
            value={`${
              chareableWeight?.boxWiseArr
                ? `${
                    selectedUnit === 'lb'
                      ? customWeightRounding(
                          (chareableWeight?.boxWiseArr[Number(id)]?.minChargeableWeight ?? 0) * 2.20462,
                        )
                      : Number(chareableWeight?.boxWiseArr?.[Number(id)]?.minChargeableWeight ?? 0).toFixed(2)
                  } - ${
                    selectedUnit === 'lb'
                      ? customWeightRounding(
                          (chareableWeight?.boxWiseArr[Number(id)]?.maxChargeableWeight ?? 0) * 2.20462,
                        )
                      : Number(chareableWeight?.boxWiseArr?.[Number(id)]?.maxChargeableWeight ?? 0).toFixed(2)
                  }`
                : (0).toFixed(2)
            } ${selectedUnit}`}
          />
          <BoxInfo label={`Dimentions(L*W*H)${selectedLengthUnit}`} value={`${length}*${width}*${height}`} />
        </Grid>
      </BoxContainer>
    </>
  );
}

export default SingleBoxView;
